import { AdminType, APIGet, APIUrl } from "api/protocols";
import { CancelToken } from "axios";


interface IGetLoyaltyCustomer {
    customer_id?: number;
    tier?: boolean; // return tier info
    limit?: number;
    offset: number;
    user?: boolean; //return customer info
    search?: string;
}


export async function GetLoyaltyCustomer(params: IGetLoyaltyCustomer, useGlobalLoader: boolean, cancelToken?: CancelToken) {
    return await APIGet(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/customer"), params, useGlobalLoader, cancelToken);
  }